import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';
import { ComprobarClientesService } from 'src/app/core/providers/services/comprobar-clientes/comprobar-clientes.service';
import { Numbers } from 'src/app/utils/constants';
import { InputModel } from '../../../../core/models/input.model';

import { CommonService } from '../../../../core/providers/forms/common.service';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit, OnChanges {

  public currValue = '';

  /**
   * @description se le pasa el formulario base
   */
  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: InputModel;
  @Input() DATA_CONFIG_FULL: any;
  @Input() DATA_CHANGE: any;
  @Input() STEP: any;
  @Input() DISABLED: any;
  @Input() NO_REQUIRED: any;
  @Output() DATA_EMIT: EventEmitter<any> = new EventEmitter();
  @Output() DATA_EMIT_BLUR: EventEmitter<any> = new EventEmitter();

  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  maxlengthNum: number;

  patternEmail: string = this.commons.patternsForm('email').toString();
  patternMobile: string = this.commons.patternsForm('mobile').toString();
  patternCP: string = this.commons.patternsForm('cp').toString();
  patternNumber: string = this.commons.patternsForm('number1').toString();
  patternPassport: RegExp = this.commons.patternsForm('passport');

  patternEmailError = false;
  patternMobileError = false;
  patternCPError = false;

  dniError = false;
  nifError = false;
  nieError = false;
  cifError = false;
  passportError = false;
  servicePromoError = false;
  validDocNumError = false;
  validDocNumMinError = false;
  rentMax24 = false;
  rentMax60 = false;
  serviceCPError = false;
  serviceCPError2 = false;
  finish = new Subject();
  isDisabled = false;
  noRequireLabel = '';

  /**
   * @description se le pasa un array de strings que será el path que enlazará
   *  la propiedad del formulario al input
   * @example ['individualTravelAsistance', 'name']
   */

  constructor(
    private commons: CommonService,
    private clients: ComprobarClientesService
  ) {
    this.commons = commons;
    this.clients = clients;
  }
  /**
   * @description metodo inicio
   */
  ngOnInit() {
    this.fieldName = this.DATA_CONFIG.linkFormPath;
    this.fieldRequired = false;
    this.maxlengthNum = parseInt(this.DATA_CONFIG.maxlength, Numbers.number10);
    this.isDisabled = false;
    if (this.DATA_CONFIG.disabled !== undefined) { this.isDisabled = this.DATA_CONFIG.disabled; }
    this.noRequireLabel = '';
    if (this.NO_REQUIRED !== undefined && this.NO_REQUIRED !== '') { this.noRequireLabel = this.NO_REQUIRED; }

    // Si viene un valor del formulario o de la configuracion lo guardamos en el formulario
    if (this.DATA_CONFIG.value && this.DATA_CONFIG.value.length > 0) {
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(this.DATA_CONFIG.value);
    } else {
      if (this.getFormValue() && this.getFormValue().length > 0) {
        this.currValue = this.getFormValue();
        if (this.currValue !== '' && this.fieldName.includes('postalCode')) {
          this.DATA_EMIT.emit({ enter: true, field: this.fieldName });
        }
      }
    }

    this.getError(this.fieldName);

    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          const AUX_SELECTED_LEGAL_2 = 'ownerLegalAsistance';
          if (this.STEP !== undefined) {
            this.validTypeDoc(el);
            if (this.STEP === 1 && this.fieldName.includes(AUX_SELECTED_LEGAL_2)) {
              this.validRent();
            }
          }
        })
      ).subscribe();
  }
  /**
   * @description metodo cambios
   * @params changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.DISABLED !== undefined && changes.DISABLED.currentValue !== undefined) {
      this.isDisabled = changes.DISABLED.currentValue;
    }

    if (changes.DATA_CHANGE !== undefined && changes.DATA_CHANGE.currentValue !== undefined) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      if (AUX_CHANGE.name !== undefined) {
        switch (AUX_CHANGE.name) {
          case 'provincia':
            this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(AUX_CHANGE.value);
            break;
          case 'cp':
            this.cpChange(AUX_CHANGE);
            break;
          case 'promo':
            this.promoChange(AUX_CHANGE);
            break;
          case 'docNumber':
            this.docNumberChange(AUX_CHANGE);
            break;
          case 'rent':
            this.rentChange(AUX_CHANGE);
            break;
          case 'prefix':
            this.maxlengthNum = parseInt(AUX_CHANGE.value, Numbers.number10);
            break;
          default:
            break;
        }
      }
    }
  }

  /**
   * @description Validar cambios en el campo zipcode
   */
  cpChange(auxChange: any): void {
    if (auxChange.value === 'error') {
      this.serviceCPError = true;
      this.serviceCPError2 = false;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
    if (auxChange.value === 'error-spain') {
      this.serviceCPError = false;
      this.serviceCPError2 = true;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
    if (auxChange.value === 'error-empty') {
      this.serviceCPError = false;
      this.serviceCPError2 = false;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
  }
  /**
   * @description Validar cambios en el campo codigo promocional
   */
  promoChange(auxChange: any): void {
    if (auxChange.value === 'error') {
      this.servicePromoError = true;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
  }
  /**
   * @description Validar cambios en el campo número de documento
   */
  docNumberChange(auxChange: any): void {
    if (auxChange.value === 'error-min') {
      this.validDocNumError = false;
      this.validDocNumMinError = true;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
    if (auxChange.value === 'error') {
      this.validDocNumError = true;
      this.fieldHasErrorB = true;
      this.validDocNumMinError = false;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
    if (auxChange.value === 'valid') {
      this.validDocNumError = false;
      this.validDocNumMinError = false;
      this.fieldHasErrorB = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }

      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
    }
  }
  /**
   * @description Validar cambios en el campo renta
   */
  rentChange(auxChange: any): void {
    if (auxChange.value === 'error' && auxChange.type === Numbers.number60) {
      this.rentMax24 = false;
      this.rentMax60 = true;
    }
    if (auxChange.value === 'error' && auxChange.type === Numbers.number24) {
      this.rentMax24 = true;
      this.rentMax60 = false;
    }
    if (auxChange.value === 'ok' && auxChange.type === Numbers.number60) {
      this.rentMax60 = false;
      this.rentMax24 = false;
    }
    if (auxChange.value === 'ok' && auxChange.type === Numbers.number24) {
      this.rentMax60 = false;
      this.rentMax24 = false;
    }

    if (this.rentMax24 || this.rentMax60) {
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      this.rentMax60 = false;
      this.rentMax24 = false;
      this.fieldHasErrorB = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }

      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
    }
  }

  /**
   * @description Validar el número de documento
   */
  validTypeDoc(el: any): void {
    const AUX_SELECTED = 'particularLegalAsistance';
    const AUX_SELECTED_2 = 'ownerLegalAsistance';
    const FIELD: string[] = this.DATA_CONFIG.linkFormPath;
    // tslint:disable-next-line: prefer-const
    let auxTypeDoc: any;
    // tslint:disable-next-line: prefer-const
    let auxType: any = {
      auxTypeDoc
    };
    if (((this.STEP === Numbers.number3 && !FIELD.includes(AUX_SELECTED_2)) ||
      (this.STEP === Numbers.number2 && FIELD.includes(AUX_SELECTED)) ||
      (this.STEP === Numbers.number2 && FIELD.includes(AUX_SELECTED_2)) ) &&
      (this.DATA_CONFIG.linkFormPath[Numbers.number2] === 'documentNumber') ) {
        auxType.auxTypeDoc = this.FORM_DATA
        .get([this.DATA_CONFIG.linkFormPath[0], this.DATA_CONFIG.linkFormPath[Numbers.number1], 'documentType']).value;
    }
    if ((this.STEP === Numbers.number4) || (this.STEP === Numbers.number3 && FIELD.includes(AUX_SELECTED_2))) {
      this.validTypeDocStep3And4includesAuxSelected2(FIELD, AUX_SELECTED_2, auxType);
    }
    if (auxType.auxTypeDoc !== undefined && auxType.auxTypeDoc.name !== undefined) {
      this.validTypeDocSet(auxType.auxTypeDoc, el);
    }
  }
  /**
   * @description validar documento paso 3 y 4
   * @params field
   * @params auxSelected2
   * @params auxType
   */
  validTypeDocStep3And4includesAuxSelected2(field: string | any[], auxSelected2: any, auxType: any): void {
    if (this.DATA_CONFIG.linkFormPath[Numbers.number0] === 'documentNumber') {
      auxType.auxTypeDoc = this.FORM_DATA.get('documentType').value;
    } else {
      if (field.includes(auxSelected2) &&
        this.DATA_CONFIG.linkFormPath[Numbers.number3] === 'documentNumber' &&
        this.DATA_CONFIG.linkFormPath[Numbers.number2] === 'owner') {
        auxType.auxTypeDoc = this.FORM_DATA.get(['ownerLegalAsistance', 'insuredListData', 'owner', 'documentType']).value;
      }
      if (field.includes(auxSelected2) &&
        this.DATA_CONFIG.linkFormPath[Numbers.number3] === 'documentNumber' &&
        this.DATA_CONFIG.linkFormPath[Numbers.number2] === 'tenant') {
        auxType.auxTypeDoc = this.FORM_DATA.get(['ownerLegalAsistance', 'insuredListData', 'tenant', 'documentType']).value;
      }
    }
  }
  /**
   * @description Validar tipo documento
   * @params auxTypeDoc
   * @params el
   */
  validTypeDocSet(auxTypeDoc: any, el: any): void {
    if (auxTypeDoc.name === 'DNI') {
      this.dniError = !this.commons.validateDNI(el);
      this.nifError = false;
      this.nieError = false;
      this.cifError = false;
      this.passportError = false;
    }
    if (auxTypeDoc.name === 'NIF') {
      this.nifError = !this.commons.validateNIF(el);
      this.nieError = false;
      this.dniError = false;
      this.cifError = false;
      this.passportError = false;
    }
    if (auxTypeDoc.name === 'NIE') {
      this.nieError = !this.commons.validateNIE(el);
      this.nifError = false;
      this.dniError = false;
      this.cifError = false;
      this.passportError = false;
    }
    if (auxTypeDoc.name === 'CIF') {
      this.cifError = this.commons.validateCif(el);
      this.nifError = false;
      this.nieError = false;
      this.dniError = false;
      this.passportError = false;
    } else {
      if (auxTypeDoc.id === Numbers.number4) {
        // this.passportError = this.commons.validatePassport(el);
        this.passportError = !this.patternPassport.test(el);
        this.dniError = false;
        this.nifError = false;
        this.nieError = false;
        this.cifError = false;
      }
    }

    if (this.dniError || this.nifError || this.nieError || this.cifError || this.passportError) {
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }

      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);

      this.dniError = false;
      this.nifError = false;
      this.nieError = false;
      this.cifError = false;
      this.passportError = false;
    }
  }
  /**
   * @description recuperar los datos relacinados con el CIF
   */
  getDataBD(): void {
    const AUX_VALUE_NUM: any = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    this.clients.getClientes(AUX_VALUE_NUM)
      .pipe(take(1))
      .subscribe((client) => {
        if (client !== null) {
          this.DATA_EMIT.emit({ enter: true, field: this.fieldName, value: client });
        }
      });
  }
  /**
   * @description validar el monto de renta
   */
  validRent(): void {
    if (this.DATA_CONFIG.linkFormPath[1] === 'monthlyRent') {
      const CONTROL: AbstractControl = this.FORM_DATA.get(this.fieldName);
      if (CONTROL.valid && CONTROL.errors === null) {
        this.DATA_EMIT.emit({ enter: true, field: this.fieldName });
      }
    }
  }
  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }
  /**
   * @description Actualiza los cambios del input desde el html
   */
  public updateData(ev: { target: { value: string } }): void {
    if (!this.checkDataCompOk()) { return; }
    let auxValue: string = ev.target.value;
    auxValue = auxValue.trim();
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(auxValue);
    if (this.fieldRequired) {
      this.updateDataFieldRequired(auxValue);
    } else {
      this.fieldHasErrorB = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
    }
  }
  /**
   * @description actualizar requeridos
   * @params auxValue
   */
  updateDataFieldRequired(auxValue: string): void {
    if (auxValue !== '' && this.STEP === undefined) {

      this.fieldHasErrorB = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
    } else if (auxValue !== '') {
      this.validTypeDoc(auxValue);
    } else {
      this.serviceCPError = false;
      this.validDocNumError = false;
      this.validDocNumMinError = false;
      this.dniError = false;
      this.cifError = false;
      this.passportError = false;
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    }
  }
  /**
   * @description Actualiza los cambios del input desde el html
   */
  public getFormValue(): string {
    if (this.checkDataCompOk()) {
      return this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    }
  }
  /**
   *
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const VALUE_EL: any = this.FORM_DATA.get(controlName).value;
    if (this.fieldRequired && VALUE_EL !== '') {
      this.fieldHasErrorB = false;
    }
    if (this.fieldRequired && VALUE_EL === '') {
      this.fieldHasErrorB = true;
    }
  }
  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    this.fieldErrors = '';
    this.fieldRequired = this.DATA_CONFIG.required;
    const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);

    if (CONTROL.invalid && CONTROL.errors !== null) {
      errorMsg = JSON.stringify(CONTROL.errors);
      this.fieldErrors = CONTROL.errors;
      if (this.fieldErrors.pattern) {
        //
      }
    }

    return errorMsg;
  }
  /**
   *
   * @param field field to check key
   */
  onKeydown(event: any): void {
    if (event.key === 'Enter') {
      this.DATA_EMIT.emit({ enter: true });
      event.preventDefault();
    }
  }
  /**
   *
   * @param field field to check 5 caracters
   */
  lengthField(event: any): void {
    const AUX_LENGTH: any = event.target.value;
    if (AUX_LENGTH.length === Numbers.number5 && this.fieldName.includes('postalCode')) {
      this.DATA_EMIT.emit({ enter: true, field: this.fieldName });
    }
  }
  /**
   * @description al retirar el foco
   * @params controlName
   */
  onBlurInput(controlName: any): void {
    if (controlName[Numbers.number2] === 'postalCode') {
      this.DATA_EMIT_BLUR.emit({ blur: true });
    }
    if (controlName[Numbers.number2] !== 'postalCode' && controlName[Numbers.number1] === 'monthlyRent') {
      this.DATA_EMIT_BLUR.emit({ blur: true, fieldName: 'monthlyRent' });
    }
    if ((controlName[Numbers.number2] !== 'postalCode' && controlName[Numbers.number1] !== 'monthlyRent') &&
      controlName[Numbers.number0] === 'ownerLegalAsistance' && controlName[Numbers.number3] === 'postalCode') {
      this.DATA_EMIT_BLUR.emit({ blur: true });
    } else {
      if (controlName.includes('documentNumber') || controlName.includes('name') || controlName.includes('firstSurname')) {
        this.DATA_EMIT_BLUR.emit({ blur: true, control: 'check-document', fieldName: controlName });
      }
    }
  }
}
